var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{style:({width: _vm.width,height: _vm.height}),attrs:{"id":"captchaCanvas","width":"80","height":"26"},on:{"click":_setup.generateCaptcha}})
}
var staticRenderFns = []

export { render, staticRenderFns }